/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

/**
 * Represents the various condition types that can be associated with a BookConnection.

Conditions are categorized into two groups:

1. [Static Conditions] These conditions are determined solely by the BookConnection's data structure
   and configuration, and they can be validated without external dependencies or runtime state:
   - BOOK_VALID
   - AUTHENTICATION_VALID
   - CONFIGURATION_VALID

2. [Dynamic Conditions] These conditions depend on external factors and runtime state that can change
   independently of the BookConnection spec. They require active monitoring and periodic re-evaluation:
   - DEPLOYMENT_READY
   - CREDENTIALS_VALID
   - DISCOVER_READY
   - TRIGGER_INSTANCES_READY
   - COMPATIBLE_RUNTIME_VERSION
   - POLL_INSTANCES_READY

 - BOOK_CONNECTION_CONDITION_TYPE_BOOK_VALID: Static
 - BOOK_CONNECTION_CONDITION_TYPE_DEPLOYMENT_READY: Dynamic
 */
export type V2BookConnectionConditionType =
  (typeof V2BookConnectionConditionType)[keyof typeof V2BookConnectionConditionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V2BookConnectionConditionType = {
  BOOK_CONNECTION_CONDITION_TYPE_BOOK_VALID:
    'BOOK_CONNECTION_CONDITION_TYPE_BOOK_VALID',
  BOOK_CONNECTION_CONDITION_TYPE_AUTHENTICATION_VALID:
    'BOOK_CONNECTION_CONDITION_TYPE_AUTHENTICATION_VALID',
  BOOK_CONNECTION_CONDITION_TYPE_CONFIGURATION_VALID:
    'BOOK_CONNECTION_CONDITION_TYPE_CONFIGURATION_VALID',
  BOOK_CONNECTION_CONDITION_TYPE_DEPLOYMENT_READY:
    'BOOK_CONNECTION_CONDITION_TYPE_DEPLOYMENT_READY',
  BOOK_CONNECTION_CONDITION_TYPE_CREDENTIALS_VALID:
    'BOOK_CONNECTION_CONDITION_TYPE_CREDENTIALS_VALID',
  BOOK_CONNECTION_CONDITION_TYPE_DISCOVER_READY:
    'BOOK_CONNECTION_CONDITION_TYPE_DISCOVER_READY',
  BOOK_CONNECTION_CONDITION_TYPE_TRIGGER_INSTANCES_READY:
    'BOOK_CONNECTION_CONDITION_TYPE_TRIGGER_INSTANCES_READY',
  BOOK_CONNECTION_CONDITION_TYPE_COMPATIBLE_RUNTIME_VERSION:
    'BOOK_CONNECTION_CONDITION_TYPE_COMPATIBLE_RUNTIME_VERSION',
  BOOK_CONNECTION_CONDITION_TYPE_POLL_INSTANCES_READY:
    'BOOK_CONNECTION_CONDITION_TYPE_POLL_INSTANCES_READY',
} as const;
